import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import { GET, POST } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { TRUCK_TYPE } from "../../utils/Utils";



const PNDeliveryFeeByDistance = () => {
  const printRef = useRef();
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [truckOptions, setTruckOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [internalData, setInternalData] = useState([]);
  const [externalData, setExternalData] = useState([]);
  const { handleSubmit, control, reset, watch, getValues, formState: { errors } } = useForm({
    defaultValues: {
      internalData: [],
      externalData: []
    }
  });

  const { fields: internalFields, append: appendInternal, remove: removeInternal, } = useFieldArray({
    control,
    name: "internalData",
  });

  const { fields: externalFields, append: appendExternal, remove: removeExternal } = useFieldArray({
    control,
    name: "externalData",
  });

  useEffect(() => {
    GET("truck", {
      type: TRUCK_TYPE.TRUCK
    }, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });

    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, [])

  useEffect(() => {
    setLoading(true);

    GET(`/delivery-fee-by-distance`, {}, true)
      .then(({ data: { rows } }) => {
        const internalData = rows.filter(e => e.location === 'INTERNAL');
        const externalData = rows.filter(e => e.location === 'EXTERNAL');
        setInternalData(internalData);
        setExternalData(externalData);
        reset({
          internalData,
          externalData
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [])

  const handleAddInternal = () => {
    const currentData = (getValues()?.data || []);
    const maxDistance = Math.max(...currentData.map(e => e.maxDistance || 0), 0)
    const data = {
      maxDistance: maxDistance || 10,
      truckIds: [],
      deliveryFeeByWeight: 0,
      deliveryFeeExternal: 0,
      driverBonus: 0,
      subDriverBonus: 0
    }
    appendInternal(data);
  }

  const handleAddExternal = () => {
    const currentData = (getValues()?.data || []);
    const maxDistance = Math.max(...currentData.map(e => e.maxDistance || 0), 0)
    const data = {
      maxDistance: maxDistance || 10,
      truckIds: [],
      deliveryFeeByWeight: 0,
      deliveryFeeExternal: 0,
      driverBonus: 0,
      subDriverBonus: 0
    }
    appendExternal(data);
  }

  const handleSubmitForm = (data) => {
    setLoading(true);
    POST("delivery-fee-by-distance", [
      ...data.internalData.map(e => ({
        ...e,
        location: 'INTERNAL'
      })),
      ...data.externalData.map(e => ({
        ...e,
        location: 'EXTERNAL'
      }))
    ], {}, true)
      .then((res) => {
        toast.success("Thêm thành công");
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <React.Fragment>
      <Head title="Cài đặt giá vận chuyển thuê"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <form onSubmit={handleSubmit(handleSubmitForm)}>
                  <div className="my-3">
                    <h5 className="text-center mt-2 mb-2">Cài đặt giá trong nước</h5>
                    <div className="text-right mb-2">
                      <Button
                        className="btn-primary"
                        color="primary"
                        type="button"
                        onClick={handleAddInternal}
                      >
                        <Icon name="plus"></Icon>
                      </Button>
                    </div>


                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Khoảng cách(km)</th>
                          <th>Nhóm Xe</th>
                          <th>Đơn giá(đ)</th>
                          <th>Tiền tài chính(đ)</th>
                          <th>Tiền tài phụ(đ)</th>
                          <th>Hành động</th>
                        </tr>
                      </thead>
                      <tbody>
                        {internalFields.map((field, index) => (
                          <tr key={`${field.id}`}>
                            <td>
                              <Controller
                                name={`internalData.${index}.distance`}
                                control={control}
                                defaultValue={field.distance}
                                rules={{
                                  required: "Vui lòng nhập dữ liệu"
                                }}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    onValueChange={(val) =>
                                      onChange(val.floatValue)
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`internalData.${index}.distance`}
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </td>
                            <td >
                              <Controller
                                name={`internalData.${index}.truckIds`}
                                defaultValue={field.truckIds}
                                control={control}
                                rules={{
                                  required: "Vui lòng nhập dữ liệu",
                                  validate: (value) => {
                                    if (!value?.length) {
                                      return "Vui lòng nhập dữ liệu";
                                    }
                                    return true;
                                  }
                                }}
                                render={({ onChange, value }) => {
                                  return <RSelect
                                    isClearable
                                    isMulti
                                    classNamePrefix="form-control"
                                    placeholder="Lọc theo xe"
                                    options={truckOptions}
                                    value={truckOptions.filter(
                                      (c) => (value || [])?.includes(c.value)
                                    )}
                                    onChange={(val) => {
                                      onChange(val?.map(e => e.value) || [])
                                    }}
                                  />
                                }}
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`internalData.${index}.truckIds`}
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </td>
                            <td>
                              <Controller
                                name={`internalData.${index}.deliveryFeeByDistance`}
                                defaultValue={field.deliveryFeeByDistance}
                                rules={{
                                  required: "Vui lòng nhập dữ liệu"
                                }}
                                control={control}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    onValueChange={(val) =>
                                      onChange(val.floatValue)
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`internalData.${index}.deliveryFeeByDistance`}
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </td>
                            <td>
                              <Controller
                                name={`internalData.${index}.driverBonus`}
                                defaultValue={field.driverBonus}
                                rules={{
                                  required: "Vui lòng nhập dữ liệu"
                                }}
                                control={control}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    onValueChange={(val) =>
                                      onChange(val.floatValue)
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`internalData.${index}.driverBonus`}
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </td>
                            <td>
                              <Controller
                                name={`internalData.${index}.subDriverBonus`}
                                defaultValue={field.subDriverBonus}
                                control={control}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    onValueChange={(val) =>
                                      onChange(val.floatValue)
                                    }
                                  />
                                )}
                              />
                            </td>
                            <td>
                              <Button
                                size="sm"
                                color="danger"
                                onClick={() => removeInternal(index)}>
                                Xóa
                              </Button>
                            </td>
                          </tr>
                        ))}

                      </tbody>
                    </table>

                  </div>
                  <div className="my-3">
                    <h5 className="text-center mt-2 mb-2">Cài đặt giá xuất khẩu</h5>
                    <div className="text-right mb-2">
                      <Button
                        className="btn-primary"
                        color="primary"
                        type="button"
                        onClick={handleAddExternal}
                      >
                        <Icon name="plus"></Icon>
                      </Button>
                    </div>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Kho</th>
                          <th>Nhóm Xe</th>
                          <th>Giá xuất khẩu(đ)</th>
                          <th>Tiền tài chính(đ)</th>
                          <th>Tiền tài phụ(đ)</th>
                          <th>Hành động</th>
                        </tr>
                      </thead>
                      <tbody>
                        {externalFields.map((field, index) => (
                          <tr key={`${field.id}`}>
                            <td>
                              <Controller
                                name={`externalData.${index}.warehouseIds`}
                                defaultValue={field.warehouseIds}
                                control={control}
                                rules={{
                                  required: "Vui lòng nhập dữ liệu",
                                  validate: (value) => {
                                    if (!value?.length) {
                                      return "Vui lòng nhập dữ liệu";
                                    }
                                    return true;
                                  }
                                }}
                                render={({ onChange, value }) => (
                                  <RSelect
                                    isClearable
                                    isMulti
                                    classNamePrefix="form-control"
                                    placeholder="Lọc theo kho"
                                    options={warehouseOptions}
                                    value={warehouseOptions.filter(
                                      (c) => (value || [])?.includes(c.value)
                                    )}
                                    onChange={(val) => {
                                      onChange(val?.map(e => e.value) || [])
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`externalData.${index}.warehouseIds`}
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </td>
                            <td >
                              <Controller
                                name={`externalData.${index}.truckIds`}
                                defaultValue={field.truckIds}
                                control={control}
                                rules={{
                                  required: "Vui lòng nhập dữ liệu",
                                  validate: (value) => {
                                    if (!value?.length) {
                                      return "Vui lòng nhập dữ liệu";
                                    }
                                    return true;
                                  }
                                }}
                                render={({ onChange, value }) => {
                                  return <RSelect
                                    isClearable
                                    isMulti
                                    classNamePrefix="form-control"
                                    placeholder="Lọc theo xe"
                                    options={truckOptions}
                                    value={truckOptions.filter(
                                      (c) => (value || [])?.includes(c.value)
                                    )}
                                    onChange={(val) => {
                                      onChange(val?.map(e => e.value) || [])
                                    }}
                                  />
                                }}
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`externalData.${index}.truckIds`}
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </td>
                            <td>
                              <Controller
                                name={`externalData.${index}.deliveryFeeExternal`}
                                defaultValue={field.deliveryFeeExternal}
                                rules={{
                                  required: "Vui lòng nhập dữ liệu"
                                }}
                                control={control}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    onValueChange={(val) =>
                                      onChange(val.floatValue)
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`externalData.${index}.deliveryFeeExternal`}
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </td>
                            <td>
                              <Controller
                                name={`externalData.${index}.driverBonus`}
                                defaultValue={field.driverBonus}
                                rules={{
                                  required: "Vui lòng nhập dữ liệu"
                                }}
                                control={control}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    onValueChange={(val) =>
                                      onChange(val.floatValue)
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`externalData.${index}.driverBonus`}
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </td>
                            <td>
                              <Controller
                                name={`externalData.${index}.subDriverBonus`}
                                defaultValue={field.subDriverBonus}

                                control={control}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    onValueChange={(val) =>
                                      onChange(val.floatValue)
                                    }
                                  />
                                )}
                              />
                            </td>
                            <td>
                              <Button
                                size="sm"
                                color="danger"
                                onClick={() => removeExternal(index)}>
                                Xóa
                              </Button>
                            </td>
                          </tr>
                        ))}

                      </tbody>
                    </table>
                  </div>
                  <Button className="text-center mt-2" type="submit" color="primary">Lưu thay đổi</Button>

                </form>

              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PNDeliveryFeeByDistance;
